// components/assignmentTexts/assType_5.js
import React from "react";
import { FaHourglassHalf, FaClock, FaCheckCircle } from "react-icons/fa";


export const makeAssType_5 = ({ book, user }) => ({
    1: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",
            icon1:  <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title1: "Access the book and read it",
            description1: "You can download the book. Once you have read the book, click the 'Next Step' button.",
            icon2:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Complete reading & review",
            description2: "We are waiting for you to finish the previous step. Then you can post your review.",
            icon3:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve review",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your review.",
            full_title1: `Purchase the Book directly from Amazon using search link below. Expenses: ${book.selectedCurrentUserAssign?.assignment_price_amz}`,
            full_subtitle1: "This is a Verified Purchase Assignment with \"Search&Buy\" option.",
            full_description1: ( <p>Do not buy the paperback version, as shipping delays will make it impossible to finish the assignment on time.

                    As a thank-you for your purchase, you’ll earn extra Virt per dollar for this assignment! However, if your review is not marked as a Verified Purchase by Amazon, these extra Virts will be removed later.

                    The review must have the 'Verified Purchase' label, which only appears if you’ve actually read or at least skimmed through the book. </p>
            ),
            full_title2: "Read the book and post your review on Amazon",
            full_subtitle2: "Note: Once you complete this step, you will not be able to cancel this assignment.",
            full_description2: ( <p>Enjoy the book and share your honest thoughts in a detailed review.
                    Click the button below to post it on Amazon. Make sure your review is original, accurate, and respectful.
                    AI-generated, plagiarized, generic, inaccurate, defamatory, or discriminatory reviews are not allowed.
                    If it doesn’t appear right away, don’t worry - Amazon may take some time to approve it.</p>
            ),
            full_title3: "Turn in this assignment",
            full_subtitle3: "We will track your review on Amazon.",
            full_description3: ( <p>Click the button below to submit your assignment. Do this immediately after posting your review on Amazon.
                    This is a required step in the review process.
                    Our staff will monitor the appearance of your review on Amazon for 14 days..</p>
            ),
            full_title4: " full_title4:step1:",
            full_subtitle4: " full_subtitle4:step1.",
            full_description4: ( <p>full_description4:step1</p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Access the book and read it",
            description1: "You have completed this step!",
            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Complete reading & review",
            description2: "You are now on the second step of the assignment. Please finish reading and post your review.",
            icon3:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve review",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your review.",
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",
            full_title2: "Complete reading and post your review on Amazon",
            full_subtitle2: "Note: Once you complete this step, you will not be able to cancel this assignment.",
            full_description2: ( <p>Enjoy the book and share your honest thoughts in a detailed review.
                    Click the button below to post it on Amazon. Make sure your review is original, accurate, and respectful.
                    AI-generated, plagiarized, generic, inaccurate, defamatory, or discriminatory reviews are not allowed.
                    If it doesn’t appear right away, don’t worry - Amazon may take some time to approve it.
                    Note: The review must have the 'Verified Purchase' label, which only appears if you’ve actually read or at least skimmed through the book.</p>
            ),
            full_title3: "Turn in this assignment",
            full_subtitle3: "We will track your review on Amazon.",
            full_description3: ( <p>Click the button below to submit your assignment. Do this immediately after posting your review on Amazon.
                    This is a required step in the review process.
                    Our staff will monitor the appearance of your review on Amazon for 14 days..</p>
            ),
            full_title4: " full_title4:step1:",
            full_subtitle4: " full_subtitle4:step1.",
            full_description4: ( <p>full_description4:step1</p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Access the book and read it",
            description1: "You have completed this step!",
            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Complete reading & review",
            description2: "You posted review. Well Done!",
            icon3:  <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title3: "Turn in this assignment",
            description3: "You are now on the third step of the assignment. Check and turn in this assignment.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve review",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your review.",
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",
            full_title2: "",
            full_subtitle2: "",
            full_description2: "",
            full_title3: "Turn in this assignment",
            full_subtitle3: "We will track your review on Amazon.",
            full_description3: ( <p>Click the button below to submit your assignment. Do this immediately after posting your review on Amazon.
                    This is a required step in the review process.
                    Our staff will monitor the appearance of your review on Amazon for 14 days..</p>
            ),
            full_title4: " full_title4:step1:",
            full_subtitle4: " full_subtitle4:step1.",
            full_description4: ( <p>full_description4:step1</p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Access the book and read it",
            description1: "You have completed this step!",
            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Complete reading & review",
            description2: "You posted review. Well Done!",
            icon3:  <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",
            icon4:  <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title4: "Awaiting for approval",
            description4: "We receive your report and will check it. Provide the direct link to your review on Amazon.",
            full_title1: "Access the book and read it for Free Well Done!",
            full_subtitle1: "",
            full_description1: "",
            full_title2: "",
            full_subtitle2: "",
            full_description2: "",
            full_title3: "",
            full_subtitle3: "",
            full_description3: "",
            full_subtitle4: "This is an This is a Verified Purchase Assignment with Search&Buy option, and its author expects that...",
            full_description4: ( <p>Your review will contain at least a few sentences, clearly convey your thoughts,
                    and not be plagiarized or AI-generated. Please ensure that you have posted a well-written review that accurately
                    reflects your opinion of the book.
                    <b> Additionally,</b> we expect that the published review matches the characteristics you previously declared:</p>
            ),
            verified_purchase: "Verified Purchase",
            photo: "Not needed",
            review_name: user?.user?.amz_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Access the book and read it",
            description1: "You have completed this step!",
            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Complete reading & review",
            description2: "You posted review. Well Done!",
            icon3:  <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",
            icon4:  <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Assignment confirmed!",
            description4: "Congratulations, this assignment is fully confirmed!",

            full_title5: "Congratulations, this assignment is fully confirmed!",
            full_subtitle5: "You can find the verification results in the table below.",
            full_description5: ( <p>Please note that if the expected parameters do not match the verification results, we will have to adjust the balance and recalculate the final earnings for this assignment.</p>),
            verified_purchase: "Verified Purchase",
            photo: "Not needed",
            review_name: user?.user?.amz_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
    }

});
